/*
 * General custom scripts
 */

/**
 * Header - hamburger toggle
 */
( () => {

	const hamburger = document.getElementById( 'p-header-hamburger' );
	const nav       = document.getElementById( 'p-header-nav' );

	if ( ! hamburger || ! nav ) {

		return;

	}

	const header = document.querySelector( '.p-header' );
	const isLightHeader = Boolean( header?.classList.contains( 'p-header--light' ) );

	if ( header && isLightHeader ) {

		/**
		 * Sync header color mode with scroll position on the homepage.
		 */
		const syncHeaderScrollState = () => {

			header.setAttribute( 'data-scrolled', window.scrollY > 20 ? 'true' : 'false' );

		};

		syncHeaderScrollState();
		window.addEventListener( 'scroll', syncHeaderScrollState, { passive: true } );

	}

	hamburger.addEventListener( 'click', () => {

		const isOpen = hamburger.getAttribute( 'aria-expanded' ) === 'true';
		hamburger.setAttribute( 'aria-expanded', String( ! isOpen ) );
		hamburger.classList.toggle( 'is-active', ! isOpen );
		nav.classList.toggle( 'is-open', ! isOpen );

	} );

	/**
	 * Close the mobile navigation and reset hamburger state.
	 */
	const closeMobileMenu = () => {

		hamburger.setAttribute( 'aria-expanded', 'false' );
		hamburger.classList.remove( 'is-active' );
		nav.classList.remove( 'is-open' );

	};

	nav.addEventListener( 'click', ( e ) => {

		if ( ! nav.classList.contains( 'is-open' ) ) {

			return;

		}

		if ( e.target.closest( 'a[href]' ) ) {

			closeMobileMenu();

		}

	} );

	document.addEventListener( 'click', ( e ) => {

		if ( header && ! header.contains( e.target ) ) {

			closeMobileMenu();

		}

	} );

	document.addEventListener( 'keydown', ( e ) => {

		if ( e.key === 'Escape' ) {

			closeMobileMenu();

		}

	} );

} )();
